export default __webpack_public_path__ + "static/media/C50OR100.2894ecb9.mp3";